import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UiThemeModule } from '@fitscovery/partner-web/ui/theme';
import { FeatureWorkoutListComponent } from './feature-workout-list/feature-workout-list.component';
import { WorkoutsPartnerWebUiWorkoutListCardModule } from '@fitscovery/partner-web/workouts/ui/ui-workout-list-card';
import { WorkoutsPartnerWebUiProgramListCardModule } from '@fitscovery/partner-web/workouts/ui/ui-program-list-card';
import { ApiWorkoutService, ApiProgramService, WorkoutState, ProgramState, ApiWorkoutUserInsightService, ApiProgramWorkoutUserInsightService } from '@fitscovery/workouts/data-access';
import { ApiPartnerService } from '@fitscovery/partner/data-access';
import { NgxsModule } from '@ngxs/store';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { Environment } from '@fitscovery/common/environments';
import { APP_ENVIRONMENT } from 'libs/workouts/data-access/src/lib/environment-injection';
import { TranslateModule } from '@ngx-translate/core';
import { IsDisplayedPipe } from './feature-workout-list/utils/is-displayed.pipe';

const UI_COMPONENTS = [
  WorkoutsPartnerWebUiWorkoutListCardModule,
  WorkoutsPartnerWebUiProgramListCardModule,
];

const routes: Routes = [
  {
    path: '',
    component: FeatureWorkoutListComponent
  }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    UI_COMPONENTS,
    UiThemeModule,
    HttpClientModule,
    TranslateModule,
    InfiniteScrollModule,
    NgxsModule.forFeature([WorkoutState, ProgramState]),],
  declarations: [FeatureWorkoutListComponent, IsDisplayedPipe],
  exports: [
    FeatureWorkoutListComponent,
    RouterModule
  ],
  providers: [
    ApiWorkoutService,
    ApiProgramService,
    ApiPartnerService,
    ApiWorkoutUserInsightService,
    ApiProgramWorkoutUserInsightService,
  ]
})
export class PartnerWebWorkoutsFeaturesWorkoutListModule {
  static forRoot(environment: Environment): ModuleWithProviders<PartnerWebWorkoutsFeaturesWorkoutListModule> {
    return {
      ngModule: PartnerWebWorkoutsFeaturesWorkoutListModule,
      providers: [{ provide: APP_ENVIRONMENT, useValue: environment }]
    };
  }
}
